



































































































































import { Component, Vue } from 'vue-property-decorator';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import ContactDetailsEdit from '@/components/Contacts/ContactEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';


@Component({
  name: 'ContactDetails',
  components: { ContactDetailsEdit }
})
export default class extends GiganautVue {
	get currentContact() {
		return ContactDetailsModule.currentContact;
	}
}
